<form #verificationForm="ngForm" (ngSubmit)="notifyFormSubmission()">
  <div class="form-group row">
    <div class="col-xs-12">
      <label class="field-label-color">This will help us reach you</label>
      <app-identifier-input [editDisabled]="editDisabled" name="contactInputField"
                            [class.form-control-plaintext]="isVerified" [class.form-control]="!isVerified"
                            [readonly]="isVerified" #contactInputField="ngModel" [(ngModel)]="inputValue"
                            (otpRequest)="onOtpRequest()" [maxlength]="maxlength" [control]="contactInputField">
      </app-identifier-input>
    </div>
    <div class="col-xs-12 mt-3" *ngIf="isOtpRequested">
      <input id="fieldOtp" name="fieldOtp" placeholder="Enter OTP" [(ngModel)]="otp" class="form-control otp-input"
             #fieldOtpInput="ngModel" required minlength="6" maxlength="6" (ngModelChange)="canEnableButton()"/>
    </div>
  </div>
</form>
